import {Component, OnInit} from '@angular/core';
import {ProductsArticleService} from './products-article.service';
import {AppComponent} from './app.component';
import {SendMailComponent} from './send-mail.component';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {ActivatedRoute, Params} from '@angular/router';
import {SuppliersService} from './suppliers.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {DateAdapter, NativeDateAdapter} from '@angular/material';
import {DatePipe} from '@angular/common';

import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
    selector: 'issue-stock_2',
    styleUrls: ['./styles/purchasing-order.component.css'],
    templateUrl: './templates/purchasing-order.component.html',
    providers: [ProductsArticleService, AuthentificationService, TransactionsService, SuppliersService, SortTable, DatePipe, SendMailComponent]
})

export class PurchasingOrder implements OnInit {

    internal_code: string;
    supplier_code: string;
    name_art: string;
    category: string = 'root';
    no_transaction: string;
    expected_delivery: any;

    session_mode: string = "RECEPTION";
    prod_list: Array<any>;
    pannier_list: any;
    validate_bt: boolean = true;
    transaction_name: string = "";
    remark: string = "";
    quantity: any = 1;
    form_not_valid: boolean = false;
    supplier_list: Array<any>;
    selected_supplier_list: Array<any> = [];
    sortedData: any = [];

    //transaction_date: Date;
    transaction_date: any;
    date_modif: Array<Date> = [];

    constructor(
        private products_article_service: ProductsArticleService,
        private supplier_service: SuppliersService,
        private app_component: AppComponent,
        private router: Router,
        private activated_route: ActivatedRoute,
        private authentification_service: AuthentificationService,
        private transactions_service: TransactionsService,
        private sort_table: SortTable,
        dateAdapter: DateAdapter<NativeDateAdapter>,
        private datepipe: DatePipe,
        private send_mail_component: SendMailComponent
    ) {
        dateAdapter.setLocale('fr-FR');
        this.transaction_date = new Date();
        this.checkUserSession();
        this.app_component.valTest = '/purchasing-order';
        this.app_component.GetParent();
    }

    ngOnInit(): void {
        this.getSuppliersList();
    }

    articleToSend(event: any) {
        this.addToPanier(event);
    }

    GetArticlesList(): void {
        this.products_article_service.GetArticlesList().then(prod_list => {this.prod_list = prod_list; this.sortedData = prod_list; this.sort_table.SetDataArray(prod_list, [{value: "name", type: ""}, {value: "stock", type: "number"}]);});
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
    }

    onDateChanged(event) {
        var date = (this.datepipe.transform(event, 'dd-MM-yyyy'));
        this.transactions_service.updateDatePurchase(date).then(pannier_list => {
            this.pannier_list = pannier_list['list'].reverse();
            if (pannier_list['list'].length !== 0) {
                this.validate_bt = false
            }
            this.SetSupplierArticle(pannier_list);
            this.initDates(this.pannier_list);
        });
    }

    addToPanier(prod: any): void {
        var date = (this.datepipe.transform(this.transaction_date, 'dd-MM-yyyy'));
        this.transactions_service.AddtoPannier(date, prod)
            .then(pannier_list => {
                this.pannier_list = pannier_list['list'].reverse();
                if (pannier_list['list'].length !== 0) {
                    this.validate_bt = false
                }
                this.SetSupplierArticle(pannier_list);
                this.initDates(this.pannier_list);
            });
    }

    initDates(list): void {
        for (var i = 0; i < list.length; i++) {
            var date = list[i].date_limit;
            var year = Number(date.split('-')[2]);
            var month = Number(date.split('-')[1]) - 1;
            var day = Number(date.split('-')[0]);
            this.date_modif[i] = new Date(year, month, day);
        }
    }

    loadSessionPurchase() {
        this.transactions_service.LoadSessionPurchase()
            .then(session_list => {
                this.GetTransactionDetails_cb(session_list['list']);
                this.SetSupplierArticle(session_list);
                if (session_list['list'].length === 0) {
                    this.validate_bt = true
                }
                this.no_transaction = "DA-" + (parseInt(session_list['last_reference']) + 1);
            });
    }

    RemoveFromPannier(prod: any): void {
        this.transactions_service.RemoveFromPannier(prod.id_article).then(pannier_list => {this.pannier_list = pannier_list['list'].reverse(); if (pannier_list['list'].length === 0) {this.validate_bt = true; this.transaction_name = "";}; this.SetSupplierArticle(pannier_list);});
    }

    EditArticleSession(prod: any): void {
        this.transactions_service.EditArticleSessionPurchase(prod.id_article).then(result => {this.pannier_list = result['list'].reverse();; this.SessionMod(result['list']); this.SetSupplierArticle(result);});
    }


    SetSupplierArticle(session: any): void {
        this.selected_supplier_list = [];
        for (let i = 0; i < session['list'].length; i++) {
            var current_supplier = session['list'][i]['current_supplier'];
            this.supplier_list[i] = session['list'][i]['supplier'];

            for (let m = 0; m < this.supplier_list[i].length; m++) {
                if (current_supplier == this.supplier_list[i][m].id_supplier) {
                    this.selected_supplier_list[i] = this.supplier_list[i][m].id_supplier;
                }
            }
        }
    }

    changeDateForThisSupplier(idx: any, time_limit: any): void {
        var someDate = this.addDays(Number(time_limit));
        var day = someDate.getDate();
        var month = someDate.getMonth();
        var year = someDate.getFullYear();
        this.date_modif[idx] = new Date(year, month, day);
    }

    addDays(numberOfDays: any) {
        var startDate = this.transaction_date;
        var returnDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate() + numberOfDays,
            startDate.getHours(),
            startDate.getMinutes(),
            startDate.getSeconds());
        return returnDate;
    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
    }

    EditAndValidateModification(prod: any, idx: number): void {
        if (prod.status === "RECEPTION") {
            this.EditArticleSession(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPurchase(prod, idx);
        }
    }

    ValidateEditArticleSessionPurchase(prod: any, idx: number): void {
        if (isNaN(prod.quantity)) {
            prod.quantity = "Valeur invalide";
            setTimeout(() => {this.loadSessionPurchase()}, 3500);
        }
        else {
            var date = (this.datepipe.transform(this.transaction_date, 'dd-MM-yyyy'));
            var date_line = (this.datepipe.transform(this.date_modif[idx], 'dd-MM-yyyy'));
            this.transactions_service.ValidateEditArticleSessionPurchase(date, date_line, prod, this.selected_supplier_list[idx])
                .then(result => {
                    this.pannier_list = result['list'].reverse();
                    this.SessionMod(result['list']);
                    this.SetSupplierArticle(result);
                    this.initDates(this.pannier_list);
                });
        }
    }

    validatePanier(): void {
        if (this.transaction_name !== "" && this.pannier_list.length !== 0) {
            let temp = this.datepipe.transform(this.transaction_date, 'yyyy-MM-dd');
            let date_email = this.datepipe.transform(this.transaction_date, 'dd-MM-yyyy');
            this.transactions_service.ValidatePannier(this.transaction_name, this.remark, this.no_transaction, temp)
                .then(result => {
                    this.pannier_list = result['list'];
                    this.form_not_valid = false;
                    this.send_mail_component.setValues("demande d'achat", this.transaction_name, this.no_transaction, date_email, result['id_transaction_details']);
                    this.transaction_name = "";
                    this.remark = "";
                    this.validate_bt = true;
                    this.send_mail_component.sendAnEmail();
                    this.no_transaction = 'DA-' + (parseInt(result['last_reference']) + 1);
                });
        } else {
            this.form_not_valid = true;
            setTimeout(() => {this.form_not_valid = false;}, 4000);
        }
    }

    GetTransactionDetails_cb(pannier_list: any): void {
        this.pannier_list = pannier_list.reverse();
        if (pannier_list) {
            this.validate_bt = false
            this.initDates(this.pannier_list);
        }
        this.activated_route.params.subscribe((params: Params) => {
            let param = params['transaction_name'];
            if (param !== undefined) {
                this.app_component.valTest = '/purchasing-order';
                this.app_component.GetParent();
                this.transaction_name = param;
            }
        });
    }

    cancelPanier(): void {
        this.transactions_service.CancelPurchaseOrder()
            .then(result => {
                this.pannier_list = result['list'];
                this.form_not_valid = false;
                this.transaction_name = "";
                this.remark = "";
                this.validate_bt = true;
                this.transaction_date = new Date();
            });
    }

    getSuppliersList(): void {
        this.supplier_service.GetSupplierList()
            .then(result => {
                this.supplier_list = result['list'];
                this.loadSessionPurchase();
            });
    }

    checkUserSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification'])
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/purchasing-order.component.ts